import React, { useState, useEffect, useRef } from 'react'
import { Select, MenuItem } from '@mui/material';
import { ConfigInfo } from '../../Alarm Functions/AlarmOverviewFunctions'
import { gsap } from 'gsap'
import AlarmInfoIconAndTitle from '../AlarmInfoIcon'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
interface Props {
    type: string | null
    channel: string | null
    model: string
    configInfo: ConfigInfo
    handleAlarmChanges: (type: string, value: string | null) => void
}

interface ChannelsAvail {
    A: boolean
    B: boolean
    C: boolean
    D: boolean
}

const Page1: React.FC<Props> = ({ type, channel, model, configInfo, handleAlarmChanges }) => {


    const intl:IntlShape = useIntl()

    const select1Ref = useRef<HTMLDivElement>(null)
    const select2Ref = useRef<HTMLDivElement>(null)
    const onRef = useRef<HTMLHeadingElement>(null)

    const [channelsAvail, setChannelsAvail] = useState<ChannelsAvail>({
        A: false,
        B: false,
        C: false,
        D: false
    })
    const[showChannels, setShowChannels] = useState<boolean>(true)

    const selectStyle = {
        width: '50%',
        margin: '20px',
        opacity: 0
        
    }

    useEffect(() => {
        const channels = {
            A: false,
            B: false,
            C: false,
            D: false
        }
        let showChannelsTemp = false
        const flowChanOptions = ['digital', 'flow', 'mnf', 'consumption']
        const pressureChanOptions = ['pressure', 'pressureDiff', 'analogDropOut', 'analog']
        if (type && flowChanOptions.includes(type)) {
            console.log(configInfo, type)
            if (configInfo.chanAType === type) {
                channels.A = true
            } else if (configInfo.chanAType === 'flow' && type !== 'flow' && type !== 'digital') {
                channels.A = true
            }
            if (configInfo.chanBType === type) {
                channels.B = true
            } else if (configInfo.chanBType === 'flow' && type !== 'flow' && type !== 'digital') {
                channels.B = true
            }

        }
        if (type && pressureChanOptions.includes(type)) {
            channels.D = true
            channels.C = true
        }
        if (Object.keys(channels).map((key: string) => {
            if (channels[key] === true) {
                showChannelsTemp = true
            }
        }))
        if (!configInfo.chanAType) {
            channels.A = false
            }
        if (!configInfo.chanBType) {
            channels.B = false
        }
        if (!configInfo.chanCType) {
            channels.C = false
        }
        if (!configInfo.chanDType) {
            channels.D = false
        }
        
        setShowChannels(showChannelsTemp)
        setChannelsAvail(channels)
    }, [type])


    useEffect(() => {
        const select1 = select1Ref?.current
        const select2 = select2Ref?.current
        const on = onRef?.current
        const tl = gsap.timeline()

        tl.to(select1, {
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        })
        tl.to(on, {
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        }, '-=0.25')
        tl.to(select2, {
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        }, '-=0.25')



    }, [])

    return (
        <div style={{ padding: 30 }}>
            {console.log(configInfo) }
            <h4 ><b><FormattedMessage id="Set Alarm Type and Channel" /></b></h4>
            <div style={{display: 'flex', width: '100%'} }>
                <div ref={select1Ref} style={selectStyle}>
                    <AlarmInfoIconAndTitle text={intl.formatMessage({ id: 'Select the type of alarm you wish to set' })} title={intl.formatMessage({ id: "Alarm Type" })} />
                    <Select
                        value={type}
                        fullWidth
                        id='mui-select-box'
                        name='type'
                        onChange={(e):void => handleAlarmChanges(e.target.name, e.target.value)}
                    >
                        {(configInfo.chanAType === 'flow' || configInfo.chanBType === 'flow') && <MenuItem value='flow'><FormattedMessage id="Flow" /></MenuItem>}
                        {/*{(configInfo.chanAType === 'flow' || configInfo.chanBType === 'flow') && <MenuItem value='consumption'><FormattedMessage id="Consumption" /></MenuItem>}*/}
                        {(configInfo.chanCType === 'pressure' || configInfo.chanDType === 'pressure') && <MenuItem value='pressure'><FormattedMessage id="Latest Pressure" /></MenuItem>}
                        {(configInfo.chanCType === 'pressure' || configInfo.chanDType === 'pressure') && <MenuItem value='pressureDiff'><FormattedMessage id="Pressure Difference" /></MenuItem>}
                        {(configInfo.chanAType === 'digital' || configInfo.chanBType === 'digital') && <MenuItem value='digital'><FormattedMessage id="Digital Triggered" /></MenuItem>}
                        {(configInfo.chanCType === 'analog' || configInfo.chanDType === 'analog') && <MenuItem value='analog'><FormattedMessage id="4-20mA Reading" /></MenuItem>}
                        {(configInfo.chanCType === 'analog' || configInfo.chanDType === 'analog') && <MenuItem value='analogDropOut'><FormattedMessage id="4-20mA Sensor Error" /></MenuItem>}
                        <MenuItem value='signal'><FormattedMessage id="Signal" /></MenuItem>
                        <MenuItem value='battery'><FormattedMessage id="Battery" /></MenuItem>
                        <MenuItem value='temperature'><FormattedMessage id="Device Temperature" /></MenuItem>
                        {(configInfo.chanAType === 'flow' || configInfo.chanBType === 'flow') && <MenuItem value='mnf'><FormattedMessage id="Minimum Night Flow" /></MenuItem>}
                        <MenuItem value='noData'><FormattedMessage id="No Data Received in 24 hours" /></MenuItem>
                        
                    </Select>
                </div>
                <h4 ref={onRef} style={{marginTop: '72px', opacity: 0} }><b>ON</b></h4>
                <div ref={select2Ref} style={selectStyle}>
                    <AlarmInfoIconAndTitle text={intl.formatMessage({ id: 'Select the channel you wish to set the alarm on (some alarms are on the device and not the channel)' })} title={intl.formatMessage({ id: 'Channel' })} />
                    {showChannels || (!showChannels && !type) ? <Select
                        value={channel}
                        fullWidth
                        disabled={!type}
                        name='channel'
                        onChange={(e): void => handleAlarmChanges(e.target.name, e.target.value)}
                    >
                        {channelsAvail.A && <MenuItem value='A'>A</MenuItem>}
                        {channelsAvail.B && <MenuItem value='B'>B</MenuItem>}
                        {channelsAvail.C && <MenuItem value='C'>C</MenuItem>}
                        {channelsAvail.D && <MenuItem value='D'>D</MenuItem>}
                    </Select>
                        :
                        <h4 style={{marginTop: '12px'} }><b><FormattedMessage id="Device" /></b></h4>}   
                </div>
            </div>
        </div>
    )
}
export default Page1